<div class="content-block">

  <div class="card primary">
    <div class="card-header">
      <h3 class="card-title">
        <i class="fa fa-chart-pie mr-1"></i>
        Articolo {{articolo?.codice}}
      </h3>
      <div class="col-lg-6 col-12">


      </div>

    </div><!-- /.card-header -->
    <div class="card-body">
      <div class="row ">

        <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">

          <div class="dx-field">
            <div class="dx-field-label">Codice </div>
            <div class="dx-field-value">
              <dx-text-box placeholder="" maxLength="50" disabled="true" [(value)]="articolo.codice">

              </dx-text-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Tipologia </div>
            <div class="dx-field-value">

              <dx-lookup [displayExpr]="getDescrExprTipologia" valueExpr="id" [dataSource]="listTipiArticoli"
                [searchEnabled]="true" [(value)]="articolo.idTipo">
              </dx-lookup>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Descrizione </div>
            <div class="dx-field-value">
              <dx-text-box placeholder="" [(value)]="articolo.descrizione">
                <dx-validator>
                  <dxi-validation-rule type="required" message="Inserire la descrizione">
                  </dxi-validation-rule>

                </dx-validator>
              </dx-text-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Taglia </div>
            <div class="dx-field-value">
              <dx-text-box placeholder="" [(value)]="articolo.taglia">
              </dx-text-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Giorni scadenza </div>
            <div class="dx-field-value">
              <dx-number-box [(value)]="articolo.scadenza">
              </dx-number-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Scorta minima </div>
            <div class="dx-field-value">
              <dx-number-box [(value)]="articolo.scortaMinima">
              </dx-number-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Giorni Lead Time </div>
            <div class="dx-field-value">
              <dx-number-box [(value)]="articolo.giorniLeadTime">
              </dx-number-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Qta Lotto riordino </div>
            <div class="dx-field-value">
              <dx-number-box [(value)]="articolo.qtaLottoRiordino">
              </dx-number-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Attivo </div>
            <div class="dx-field-value">
              <dx-check-box [(value)]="articolo.attivo"></dx-check-box>

            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Note </div>
            <div class="dx-field-value">
              <dx-text-area placeholder="" [(value)]="articolo.note">
              </dx-text-area>

            </div>
          </div>

        </div>
        <div class="col-3 offset-3">
          @if (showAvvisoDaCompletare) {
            <div>
              <h4><img data-toggle="tooltip" data-placement="top" title="Alert" class="grid-icon"
                src="assets/icons/alert_triangle.png" alt="Allerta"/>
                Anagrafica articolo da completare
              </h4>
            </div>
          }
          @if (showAvvisoDaSostituire) {
            <div>
              <h4><img data-toggle="tooltip" data-placement="top" title="Alert" class="grid-icon"
                src="assets/icons/alert_triangle.png" alt="Allerta"/>
                Articolo da sostituire
              </h4>
            </div>
          }
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="buttons">
            <div class="buttons-column">
              <dx-button stylingMode="contained" text="Salva" icon="save" type="success" width="120"
                (onClick)="onBtnSalvaArticolo()">
              </dx-button>
            </div>

          </div>
        </div>
      </div>
    </div><!-- /.card-body -->

  </div>
  <!-- /.card -->

</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>